document.addEventListener('DOMContentLoaded', (event) => {
  var coll = document.getElementsByClassName("collapsibleuz");
  for (var i = 0; i < coll.length; i++) {
    var content = coll[i].nextElementSibling;
    
    // Open the collapsible tab by default
    coll[i].classList.add("active");
    content.style.maxHeight = content.scrollHeight + "px";

    coll[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var content = this.nextElementSibling;
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  }
});
function reviewsinitializeSwiper() {
    var swiper = new Swiper(".u-mySwiper", {
    spaceBetween: 30,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      348: {
        centeredSlides: true,
        slidesPerView: 1.3,
        spaceBetween: 10,
        centeredSlidesBounds: true,
      },
      640: {
        slidesPerView: 2.2,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween:20,
      }
    }
  });
}


var newcoll = document.getElementsByClassName("newcollapsibleuz");
  var i;
  for (i = 0; i < newcoll.length; i++) {
   newcoll[i].addEventListener("click", function() {
   this.classList.toggle("active");
   var newcontent = this.nextElementSibling;
    if (newcontent.style.maxHeight){
      newcontent.style.maxHeight = null;
    } else {
      newcontent.style.maxHeight = newcontent.scrollHeight + "px";
    } 
  });
}




